module.exports = __webpack_public_path__ + "media/17.961b63e6.wav";